define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CPUserImportModel = /** @class */ (function () {
        function CPUserImportModel(data) {
            this.FirstName = ko.observable();
            this.LastName = ko.observable();
            this.Email = ko.observable();
            this.PhoneNumber = ko.observable();
            this.Extension = ko.observable();
            this.RoleId = ko.observable();
            this.RoleName = ko.observable();
            this.Approved = ko.observable();
            this.UseManualReportsFiltering = ko.observable();
            this.EnableCouterPath = ko.observable();
            this.EnableLdap = ko.observable();
            this.EnableCPLogin = ko.observable();
            this.SendInvitation = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CPUserImportModel.Mapping, self);
            }
        }
        CPUserImportModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CPUserImportModel(options.data);
            }
        };
        return CPUserImportModel;
    }());
    return CPUserImportModel;
});
//# sourceMappingURL=CPUserImportModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CPUserImportModel.js
// module id = 175
// module chunks = 2